import { addressClient } from "@core/clients";
import { Address, User } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ADDRESSES_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

type Options = UseQueryOptions<Address[] | null, unknown, Address[] | null, string[]>;

type Props = {
  customerId: User["id"] | undefined;
  options?: Options;
};

const useGetCustomerAddresses = ({ options, customerId }: Props) => {
  return useQuery(
    ["customer-address", "get"],
    async () => {
      return await addressClient.getCustomerAddresses(customerId!);
    },
    {
      staleTime: ADDRESSES_CACHE_EXPIRE_TIME_MS,
      cacheTime: ADDRESSES_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetCustomerAddresses;
